module.exports = __webpack_public_path__ + "static/media/profilePicture.b6681619.png";